import React from 'react'
import './SpeRequiredModal.css'
import { Button } from 'flowbite-react';

interface Props {
  isOpen: boolean
  onClose: () => void
}

export const SpeRequiredModal: React.FC<Props> = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  const redirectToSuperPortal = () => {
    window.location.href = process.env.VITE_APP_SUPERPORTAL_ADDRESS
  }

  const closeModal = () => {
    onClose()
  }

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-content max-w-[700px]">
        <div className="modal-body text-left grid grid-cols-[25%_75%] gap-6">
          <div className="flex items-center justify-center">
            <img src='/images/day_calendar.svg' />
          </div>
          <div style={{ width: "85%" }}>
            <h5 className="modal-title mb-3 text-[78px]">
              Encerramos seu acesso por aqui, <br />
              faça sua gestão de Vale-Transporte pelo SuperPortal VR.
            </h5>
            <p className="mb-3">
              Agora, você vai <strong>entrar no SuperPortal VR para usar os serviços que contratou.</strong> Nele você ainda pode conhecer outras soluções para impulsionar seu negócio.
            </p>
            <p className="text-muted mb-4">
              <strong>Dica:</strong> para entrar mais rápido na próxima vez, salve o link do SuperPortal nos favoritos do seu navegador.
            </p>
            <div className="grid grid-cols-[30%_70%] gap-4 mt-6">
              <div className="mt-6">
                <Button
                  className="rounded-3xl"
                  type="button"
                  color="light"
                  onClick={closeModal}
                >
                  Fechar
                </Button>
              </div>
              <div className="flex justify-end">
                <a
                  className="rounded-3xl custom-modal-button w-auto"
                  onClick={redirectToSuperPortal}
                >
                  Ir para SuperPortal VR
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
